import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const WidgetPreviewContainer = /*#__PURE__*/_styled("div", {
  target: "es44anv0",
  label: "WidgetPreviewContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1wf5os2",
  styles: "margin:15px 2px"
} : {
  name: "1wf5os2",
  styles: "margin:15px 2px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9XaWRnZXRQcmV2aWV3Q29udGFpbmVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV5QyIsImZpbGUiOiIuLi8uLi9zcmMvV2lkZ2V0UHJldmlld0NvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgV2lkZ2V0UHJldmlld0NvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIG1hcmdpbjogMTVweCAycHg7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBXaWRnZXRQcmV2aWV3Q29udGFpbmVyO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export default WidgetPreviewContainer;